export default __webpack_public_path__ + "static/media/eric.77aed977.png";